import React from "react";

export default function Heading({ item }) {
  return <h1 style={{ fontSize: item.fontSize + "px" }}>{item.label}</h1>;
}
